const enareaData = []
const countryData = [
  { ID: 1, Name: 'Mainland China' },
  { ID: 2, Name: 'Hong Kong, China' },
  { ID: 3, Name: 'Macao, China' },
  { ID: 4, Name: 'Taiwan, China' },
  { ID: 5, Name: 'Other countries and regions' },
]
const provinceData = [
  { Country: 1, ID: 1, Name: 'Beijing' },
  { Country: 1, ID: 2, Name: 'Jilin Province' },
  { Country: 1, ID: 3, Name: 'Heilongjiang Province' },
  { Country: 1, ID: 4, Name: 'Shanghai' },
  { Country: 1, ID: 5, Name: 'Jiangsu Province' },
  { Country: 1, ID: 6, Name: 'Zhejiang Province' },
  { Country: 1, ID: 7, Name: 'Anhui Province' },
  { Country: 1, ID: 8, Name: 'Fujian Province' },
  { Country: 1, ID: 9, Name: 'Jiangxi Province' },
  { Country: 1, ID: 10, Name: 'Shandong Province' },
  { Country: 1, ID: 11, Name: 'Henan Province' },
  { Country: 1, ID: 12, Name: 'Hubei Province' },
  { Country: 1, ID: 13, Name: 'Hunan Province' },
  { Country: 1, ID: 14, Name: 'Guangdong Province' },
  { Country: 1, ID: 15, Name: 'Guangxi Zhuang Autonomous Region' },
  { Country: 1, ID: 16, Name: 'Hainan Province' },
  { Country: 1, ID: 17, Name: 'chongqing' },
  { Country: 1, ID: 18, Name: 'Sichuan Province' },
  { Country: 1, ID: 19, Name: 'Guizhou Province' },
  { Country: 1, ID: 20, Name: 'Yunnan Province' },
  { Country: 1, ID: 21, Name: 'Tibet Autonomous Region' },
  { Country: 1, ID: 22, Name: 'Shanxi Province' },
  { Country: 1, ID: 23, Name: 'Gansu province' },
  { Country: 1, ID: 24, Name: 'Qinghai Province' },
  { Country: 1, ID: 25, Name: 'Ningxia Hui Autonomous Region' },
  { Country: 1, ID: 26, Name: 'Xinjiang Uygur Autonomous Region' },
  { Country: 4, ID: 27, Name: 'Taiwan Province' },
  { Country: 2, ID: 28, Name: 'Hong Kong Special Administrative Region' },
  { Country: 3, ID: 29, Name: 'Macao Special Administrative Region' },
  { Country: 5, ID: 30, Name: 'overseas' },
  { Country: 1, ID: 31, Name: 'Tianjin' },
  { Country: 1, ID: 32, Name: 'Liaoning Province' },
  { Country: 1, ID: 33, Name: 'Inner Mongolia Autonomous Region' },
  { Country: 1, ID: 34, Name: 'Shanxi Province' },
  { Country: 1, ID: 35, Name: 'Hebei Province' },
  { Country: 2, ID: 36, Name: 'other' },
]
const cityData = [
  { Province: 1, ID: 1, Name: 'Beijing city' },
  { Province: 2, ID: 2, Name: 'Changchun' },
  { Province: 2, ID: 3, Name: 'Jilin City' },
  { Province: 2, ID: 4, Name: 'Siping' },
  { Province: 2, ID: 5, Name: 'Liaoyuan City' },
  { Province: 2, ID: 6, Name: 'Tonghua' },
  { Province: 2, ID: 7, Name: 'Baishan' },
  { Province: 2, ID: 8, Name: 'Songyuan City' },
  { Province: 2, ID: 9, Name: 'Baicheng City' },
  { Province: 2, ID: 10, Name: 'Yanbian Korean Autonomous Prefecture' },
  { Province: 3, ID: 11, Name: 'Harbin City' },
  { Province: 3, ID: 12, Name: 'Qiqihar City' },
  { Province: 3, ID: 13, Name: 'Jixi' },
  { Province: 3, ID: 14, Name: 'Hegang City' },
  { Province: 3, ID: 15, Name: 'Shuangyashan' },
  { Province: 3, ID: 16, Name: 'Daqing City' },
  { Province: 3, ID: 17, Name: 'Yichun' },
  { Province: 3, ID: 18, Name: 'Jiamusi' },
  { Province: 3, ID: 19, Name: 'Qitaihe' },
  { Province: 3, ID: 20, Name: 'Mudanjiang' },
  { Province: 3, ID: 21, Name: 'Heihe' },
  { Province: 3, ID: 22, Name: 'Suihua City' },
  { Province: 3, ID: 23, Name: 'Greater Khingan Mountains' },
  { Province: 4, ID: 24, Name: 'Shanghai' },
  { Province: 5, ID: 25, Name: 'Nanjing' },
  { Province: 5, ID: 26, Name: 'Wuxi' },
  { Province: 5, ID: 27, Name: 'Xuzhou' },
  { Province: 5, ID: 28, Name: 'Changzhou City' },
  { Province: 5, ID: 29, Name: 'Suzhou City' },
  { Province: 5, ID: 30, Name: 'Nantong city' },
  { Province: 5, ID: 31, Name: 'Lianyungang City' },
  { Province: 5, ID: 32, Name: 'Huaian city' },
  { Province: 5, ID: 33, Name: 'Yancheng' },
  { Province: 5, ID: 34, Name: 'Yangzhou' },
  { Province: 5, ID: 35, Name: 'Zhenjiang' },
  { Province: 5, ID: 36, Name: 'Taizhou' },
  { Province: 5, ID: 37, Name: 'Suqian' },
  { Province: 6, ID: 38, Name: 'Hangzhou' },
  { Province: 6, ID: 39, Name: 'Ningbo' },
  { Province: 6, ID: 40, Name: 'Wenzhou city' },
  { Province: 6, ID: 41, Name: 'Jiaxing' },
  { Province: 6, ID: 42, Name: 'Huzhou' },
  { Province: 6, ID: 43, Name: 'Shaoxing' },
  { Province: 6, ID: 44, Name: 'Jinhua City' },
  { Province: 6, ID: 45, Name: 'Quzhou' },
  { Province: 6, ID: 46, Name: 'Zhoushan' },
  { Province: 6, ID: 47, Name: 'Taizhou' },
  { Province: 6, ID: 48, Name: 'Yeosu' },
  { Province: 7, ID: 49, Name: 'Hefei' },
  { Province: 7, ID: 50, Name: 'Wuhu' },
  { Province: 7, ID: 51, Name: 'Bengbu' },
  { Province: 7, ID: 52, Name: 'Huainan City' },
  { Province: 7, ID: 53, Name: "Ma'anshan" },
  { Province: 7, ID: 54, Name: 'Huaibei City' },
  { Province: 7, ID: 55, Name: 'Tongling' },
  { Province: 7, ID: 56, Name: 'Anqing' },
  { Province: 7, ID: 57, Name: 'Huangshan City' },
  { Province: 7, ID: 58, Name: 'Chuzhou' },
  { Province: 7, ID: 59, Name: 'Fuyang' },
  { Province: 7, ID: 60, Name: 'Suzhou City' },
  { Province: 7, ID: 61, Name: "Lu'an" },
  { Province: 7, ID: 62, Name: 'Bozhou' },
  { Province: 7, ID: 63, Name: 'Chizhou' },
  { Province: 7, ID: 64, Name: 'Xuancheng' },
  { Province: 8, ID: 65, Name: 'Fuzhou' },
  { Province: 8, ID: 66, Name: 'Xiamen City' },
  { Province: 8, ID: 67, Name: 'Putian City' },
  { Province: 8, ID: 68, Name: 'Sanming' },
  { Province: 8, ID: 69, Name: 'quanzhou city' },
  { Province: 8, ID: 70, Name: 'zhangzhou' },
  { Province: 8, ID: 71, Name: 'Nanping' },
  { Province: 8, ID: 72, Name: 'longyan' },
  { Province: 8, ID: 73, Name: 'ningde' },
  { Province: 9, ID: 74, Name: 'nanchang' },
  { Province: 9, ID: 75, Name: 'Jingdezhen' },
  { Province: 9, ID: 76, Name: 'Pingxiang' },
  { Province: 9, ID: 77, Name: 'Jiujiang' },
  { Province: 9, ID: 78, Name: 'Xinyu City' },
  { Province: 9, ID: 79, Name: 'Yingtan City' },
  { Province: 9, ID: 80, Name: 'Ganzhou City' },
  { Province: 9, ID: 81, Name: "Ji'an" },
  { Province: 9, ID: 82, Name: 'Yichun' },
  { Province: 9, ID: 83, Name: 'Fuzhou' },
  { Province: 9, ID: 84, Name: 'Shangrao' },
  { Province: 10, ID: 85, Name: 'Jinan City' },
  { Province: 10, ID: 86, Name: 'Qingdao' },
  { Province: 10, ID: 87, Name: 'Zibo City' },
  { Province: 10, ID: 88, Name: 'Zaozhuang City' },
  { Province: 10, ID: 89, Name: 'Dongying City' },
  { Province: 10, ID: 90, Name: 'Yantai' },
  { Province: 10, ID: 91, Name: 'Weifang' },
  { Province: 10, ID: 92, Name: 'Jining City' },
  { Province: 10, ID: 93, Name: "Tai'an" },
  { Province: 10, ID: 94, Name: 'Weihai' },
  { Province: 10, ID: 95, Name: 'Rizhao' },
  { Province: 10, ID: 96, Name: 'Laiwu' },
  { Province: 10, ID: 97, Name: 'Linyi City' },
  { Province: 10, ID: 98, Name: 'Dezhou' },
  { Province: 10, ID: 99, Name: 'Liaocheng' },
  { Province: 10, ID: 100, Name: 'Binzhou' },
  { Province: 10, ID: 101, Name: 'Heze City' },
  { Province: 11, ID: 102, Name: 'Zhengzhou City' },
  { Province: 11, ID: 103, Name: 'Kaifeng' },
  { Province: 11, ID: 104, Name: 'Luoyang City' },
  { Province: 11, ID: 105, Name: 'Pingdingshan' },
  { Province: 11, ID: 106, Name: 'Anyang' },
  { Province: 11, ID: 107, Name: 'Hebi City' },
  { Province: 11, ID: 108, Name: 'Xinxiang City' },
  { Province: 11, ID: 109, Name: 'Jiaozuo' },
  { Province: 11, ID: 110, Name: 'Jiyuan City' },
  { Province: 11, ID: 111, Name: 'Puyang City' },
  { Province: 11, ID: 112, Name: 'Xuchang' },
  { Province: 11, ID: 113, Name: 'Luohe' },
  { Province: 11, ID: 114, Name: 'Sanmenxia' },
  { Province: 11, ID: 115, Name: 'Nanyang' },
  { Province: 11, ID: 116, Name: 'Shangqiu' },
  { Province: 11, ID: 117, Name: 'Xinyang' },
  { Province: 11, ID: 118, Name: 'Zhoukou' },
  { Province: 11, ID: 119, Name: 'Zhumadian City' },
  { Province: 12, ID: 120, Name: 'Wuhan' },
  { Province: 12, ID: 121, Name: 'huangshi' },
  { Province: 12, ID: 122, Name: 'Shiyan' },
  { Province: 12, ID: 123, Name: 'Yichang City' },
  { Province: 12, ID: 124, Name: 'Xiangyang City' },
  { Province: 12, ID: 125, Name: 'Ezhou' },
  { Province: 12, ID: 126, Name: 'Jingmen' },
  { Province: 12, ID: 127, Name: 'Xiaogan City' },
  { Province: 12, ID: 128, Name: 'Jingzhou' },
  { Province: 12, ID: 129, Name: 'Huanggang City' },
  { Province: 12, ID: 130, Name: 'Xianning' },
  { Province: 12, ID: 131, Name: 'Suizhou' },
  { Province: 12, ID: 132, Name: 'Enshi Tujia and Miao Autonomous Prefecture' },
  { Province: 12, ID: 133, Name: 'Xiantao' },
  { Province: 12, ID: 134, Name: 'Qianjiang' },
  { Province: 12, ID: 135, Name: 'Tianmen City' },
  { Province: 12, ID: 136, Name: 'Shennongjia Forest Area' },
  { Province: 13, ID: 137, Name: 'Changsha City' },
  { Province: 13, ID: 138, Name: 'Zhuzhou' },
  { Province: 13, ID: 139, Name: 'Xiangtan City' },
  { Province: 13, ID: 140, Name: 'Hengyang' },
  { Province: 13, ID: 141, Name: 'Shaoyang' },
  { Province: 13, ID: 142, Name: 'Yueyang City' },
  { Province: 13, ID: 143, Name: 'Changde' },
  { Province: 13, ID: 144, Name: 'Zhangjiajie' },
  { Province: 13, ID: 145, Name: 'Yiyang City' },
  { Province: 13, ID: 146, Name: '郴州市' },
  { Province: 13, ID: 147, Name: 'Yongzhou' },
  { Province: 13, ID: 148, Name: 'Huaihua City' },
  { Province: 13, ID: 149, Name: 'Loudi' },
  { Province: 13, ID: 150, Name: 'Xiangxi Tujia and Miao Autonomous Prefecture' },
  { Province: 14, ID: 151, Name: 'Guangzhou City' },
  { Province: 14, ID: 152, Name: 'Shaoguan City' },
  { Province: 14, ID: 153, Name: 'Shenzhen' },
  { Province: 14, ID: 154, Name: 'Zhuhai city' },
  { Province: 14, ID: 155, Name: 'Shantou' },
  { Province: 14, ID: 156, Name: 'Foshan City' },
  { Province: 14, ID: 157, Name: 'Jiangmen' },
  { Province: 14, ID: 158, Name: 'Zhanjiang' },
  { Province: 14, ID: 159, Name: 'Maoming City' },
  { Province: 14, ID: 160, Name: 'Zhaoqing' },
  { Province: 14, ID: 161, Name: 'Huizhou' },
  { Province: 14, ID: 162, Name: 'Meizhou' },
  { Province: 14, ID: 163, Name: 'Shanwei' },
  { Province: 14, ID: 164, Name: 'Heyuan City' },
  { Province: 14, ID: 165, Name: 'Yangjiang' },
  { Province: 14, ID: 166, Name: 'Qingyuan' },
  { Province: 14, ID: 167, Name: 'Dongguan city' },
  { Province: 14, ID: 168, Name: 'Zhongshan City' },
  { Province: 14, ID: 169, Name: 'Chaozhou' },
  { Province: 14, ID: 170, Name: 'Jieyang' },
  { Province: 14, ID: 171, Name: 'Yunfu City' },
  { Province: 15, ID: 172, Name: 'NanNing City' },
  { Province: 15, ID: 173, Name: 'Liuzhou' },
  { Province: 15, ID: 174, Name: 'Guilin' },
  { Province: 15, ID: 175, Name: 'Wuzhou' },
  { Province: 15, ID: 176, Name: 'Beihai' },
  { Province: 15, ID: 177, Name: 'Fangchenggang' },
  { Province: 15, ID: 178, Name: 'Qinzhou' },
  { Province: 15, ID: 179, Name: 'Guigang City' },
  { Province: 15, ID: 180, Name: 'Yulin City' },
  { Province: 15, ID: 181, Name: 'Baise' },
  { Province: 15, ID: 182, Name: 'Hezhou City' },
  { Province: 15, ID: 183, Name: 'Hechi' },
  { Province: 15, ID: 184, Name: 'Laibin City' },
  { Province: 15, ID: 185, Name: 'Chongzuo' },
  { Province: 16, ID: 186, Name: 'Haikou' },
  { Province: 16, ID: 187, Name: 'Sanya' },
  { Province: 16, ID: 188, Name: 'Wuzhishan' },
  { Province: 16, ID: 189, Name: 'Qionghai' },
  { Province: 16, ID: 190, Name: 'Danzhou' },
  { Province: 16, ID: 191, Name: 'Wenchang' },
  { Province: 16, ID: 192, Name: 'Wanning' },
  { Province: 16, ID: 193, Name: 'Dongfang' },
  { Province: 16, ID: 194, Name: "Ding'an County" },
  { Province: 16, ID: 195, Name: 'Tunchang County' },
  { Province: 16, ID: 196, Name: 'Chengmai County' },
  { Province: 16, ID: 197, Name: 'Lingao County' },
  { Province: 16, ID: 198, Name: 'Baisha Li Autonomous County' },
  { Province: 16, ID: 199, Name: 'Changjiang Li Autonomous County' },
  { Province: 16, ID: 200, Name: 'Ledong Li Autonomous County' },
  { Province: 16, ID: 201, Name: 'Lingshui Li Autonomous County' },
  { Province: 16, ID: 202, Name: 'Baoting Li and Miao Autonomous County' },
  { Province: 16, ID: 203, Name: 'Qiongzhong Li and Miao Autonomous County' },
  { Province: 16, ID: 204, Name: 'Paracel Islands' },
  { Province: 16, ID: 205, Name: 'Spratly Islands' },
  { Province: 16, ID: 206, Name: 'The islands and reefs of the Zhongsha Islands and their waters' },
  { Province: 17, ID: 207, Name: 'Chongqing' },
  { Province: 18, ID: 208, Name: 'Chengdu' },
  { Province: 18, ID: 209, Name: 'Zigong' },
  { Province: 18, ID: 210, Name: 'Panzhihua City' },
  { Province: 18, ID: 211, Name: 'Luzhou' },
  { Province: 18, ID: 212, Name: 'Deyang' },
  { Province: 18, ID: 213, Name: 'Mianyang' },
  { Province: 18, ID: 214, Name: 'Guangyuan City' },
  { Province: 18, ID: 215, Name: 'Suining' },
  { Province: 18, ID: 216, Name: 'Neijiang' },
  { Province: 18, ID: 217, Name: 'Leshan city' },
  { Province: 18, ID: 218, Name: 'Nanchong' },
  { Province: 18, ID: 219, Name: 'Meishan' },
  { Province: 18, ID: 220, Name: 'Yibin City' },
  { Province: 18, ID: 221, Name: "Guang'an City" },
  { Province: 18, ID: 222, Name: 'Dazhou' },
  { Province: 18, ID: 223, Name: "Ya'an city" },
  { Province: 18, ID: 224, Name: 'Bazhong' },
  { Province: 18, ID: 225, Name: 'Ziyang City' },
  { Province: 18, ID: 226, Name: 'Aba Tibetan and Qiang Autonomous Prefecture' },
  { Province: 18, ID: 227, Name: 'Garze Tibetan Autonomous Prefecture' },
  { Province: 18, ID: 228, Name: 'Liangshan Yi Autonomous Prefecture' },
  { Province: 19, ID: 229, Name: 'Guiyang City' },
  { Province: 19, ID: 230, Name: 'Liupanshui City' },
  { Province: 19, ID: 231, Name: 'Zunyi City' },
  { Province: 19, ID: 232, Name: 'Anshun' },
  { Province: 19, ID: 233, Name: 'Tongren area' },
  { Province: 19, ID: 234, Name: 'Qianxinan Buyi and Miao Autonomous Prefecture' },
  { Province: 19, ID: 235, Name: 'Bijie area' },
  { Province: 19, ID: 236, Name: 'Qiandongnan Miao and Dong Autonomous Prefecture' },
  { Province: 19, ID: 237, Name: 'Qiannan Buyi and Miao Autonomous Prefecture' },
  { Province: 20, ID: 238, Name: 'Kunming' },
  { Province: 20, ID: 239, Name: 'Qujing' },
  { Province: 20, ID: 240, Name: 'Yuxi' },
  { Province: 20, ID: 241, Name: 'Baoshan City' },
  { Province: 20, ID: 242, Name: 'Zhaotong City' },
  { Province: 20, ID: 243, Name: 'Lijiang City' },
  { Province: 20, ID: 244, Name: "Pu'er City" },
  { Province: 20, ID: 245, Name: 'Lincang' },
  { Province: 20, ID: 246, Name: 'Chuxiong Yi Autonomous Prefecture' },
  { Province: 20, ID: 247, Name: 'Honghe Hani and Yi Autonomous Prefecture' },
  { Province: 20, ID: 248, Name: 'Wenshan Zhuang and Miao Autonomous Prefecture' },
  { Province: 20, ID: 249, Name: 'Xishuangbanna Dai Autonomous Prefecture' },
  { Province: 20, ID: 250, Name: 'Dali Bai Autonomous Prefecture' },
  { Province: 20, ID: 251, Name: 'Dehong Dai and Jingpo Autonomous Prefecture' },
  { Province: 20, ID: 252, Name: 'Nujiang Lisu Autonomous Prefecture' },
  { Province: 20, ID: 253, Name: 'Diqing Tibetan Autonomous Prefecture' },
  { Province: 21, ID: 254, Name: 'Lhasa' },
  { Province: 21, ID: 255, Name: 'Chamdo area' },
  { Province: 21, ID: 256, Name: 'Shannan area' },
  { Province: 21, ID: 257, Name: 'Shigatse area' },
  { Province: 21, ID: 258, Name: 'Nagqu area' },
  { Province: 21, ID: 259, Name: 'Ali area' },
  { Province: 21, ID: 260, Name: 'Nyingchi area' },
  { Province: 22, ID: 261, Name: "Xi'an" },
  { Province: 22, ID: 262, Name: 'Tongchuan' },
  { Province: 22, ID: 263, Name: 'Baoji City' },
  { Province: 22, ID: 264, Name: 'Xianyang' },
  { Province: 22, ID: 265, Name: 'Weinan' },
  { Province: 22, ID: 266, Name: "Yan'an City" },
  { Province: 22, ID: 267, Name: 'Hanzhong' },
  { Province: 22, ID: 268, Name: 'Yulin City' },
  { Province: 22, ID: 269, Name: 'Ankang' },
  { Province: 22, ID: 270, Name: 'Shangluo' },
  { Province: 23, ID: 271, Name: "Lan'Zhou City" },
  { Province: 23, ID: 272, Name: 'Jiayuguan City' },
  { Province: 23, ID: 273, Name: 'Jinchang City' },
  { Province: 23, ID: 274, Name: 'Baiyin' },
  { Province: 23, ID: 275, Name: 'Tianshui' },
  { Province: 23, ID: 276, Name: 'Wuwei' },
  { Province: 23, ID: 277, Name: 'Zhangye City' },
  { Province: 23, ID: 278, Name: 'Pingliang' },
  { Province: 23, ID: 279, Name: 'Jiuquan' },
  { Province: 23, ID: 280, Name: 'Qingyang' },
  { Province: 23, ID: 281, Name: 'Dingxi' },
  { Province: 23, ID: 282, Name: 'Longnan' },
  { Province: 23, ID: 283, Name: 'Linxia Hui Autonomous Prefecture' },
  { Province: 23, ID: 284, Name: 'Gannan Tibetan Autonomous Prefecture' },
  { Province: 24, ID: 285, Name: 'Xining' },
  { Province: 24, ID: 286, Name: 'Haidong area' },
  { Province: 24, ID: 287, Name: 'Haibei Tibetan Autonomous Prefecture' },
  { Province: 24, ID: 288, Name: 'Huangnan Tibetan Autonomous Prefecture' },
  { Province: 24, ID: 289, Name: 'Hainan Tibetan Autonomous Prefecture' },
  { Province: 24, ID: 290, Name: 'Guoluo Tibetan Autonomous Prefecture' },
  { Province: 24, ID: 291, Name: 'Yushu Tibetan Autonomous Prefecture' },
  { Province: 24, ID: 292, Name: 'Haixi Mongolian and Tibetan Autonomous Prefecture' },
  { Province: 25, ID: 293, Name: 'Yinchuan' },
  { Province: 25, ID: 294, Name: 'Shizuishan' },
  { Province: 25, ID: 295, Name: 'Wuzhong City' },
  { Province: 25, ID: 296, Name: 'Guyuan City' },
  { Province: 25, ID: 297, Name: 'Zhongwei' },
  { Province: 26, ID: 298, Name: 'Urumqi' },
  { Province: 26, ID: 299, Name: 'Karamay' },
  { Province: 26, ID: 300, Name: 'Turpan area' },
  { Province: 26, ID: 301, Name: 'Hami area' },
  { Province: 26, ID: 302, Name: 'Changji Hui Autonomous Prefecture' },
  { Province: 26, ID: 303, Name: 'Bortala Mongolian Autonomous Prefecture' },
  { Province: 26, ID: 304, Name: 'Bayingoleng Mongolian Autonomous Prefecture' },
  { Province: 26, ID: 305, Name: 'Aksu Region' },
  { Province: 26, ID: 306, Name: 'Kyzilsu Kirgiz Autonomous Prefecture' },
  { Province: 26, ID: 307, Name: 'Kashgar area' },
  { Province: 26, ID: 308, Name: 'Hotan area' },
  { Province: 26, ID: 309, Name: 'Ili Kazakh Autonomous Prefecture' },
  { Province: 26, ID: 310, Name: 'Tacheng area' },
  { Province: 26, ID: 311, Name: 'Altay Region' },
  { Province: 26, ID: 312, Name: 'Shihezi' },
  { Province: 26, ID: 313, Name: 'Aral City' },
  { Province: 26, ID: 314, Name: 'Tumshuk City' },
  { Province: 26, ID: 315, Name: 'Wujiaqu' },
  { Province: 27, ID: 316, Name: 'Taipei City' },
  { Province: 27, ID: 317, Name: 'Kaohsiung City' },
  { Province: 27, ID: 318, Name: 'Tainan City' },
  { Province: 27, ID: 319, Name: 'Taichung City' },
  { Province: 27, ID: 320, Name: 'Kinmen County' },
  { Province: 27, ID: 321, Name: 'Nantou County' },
  { Province: 27, ID: 322, Name: 'Keelung City' },
  { Province: 27, ID: 323, Name: 'Hsinchu City' },
  { Province: 27, ID: 324, Name: 'Chiayi City' },
  { Province: 27, ID: 325, Name: 'New Taipei City' },
  { Province: 27, ID: 326, Name: 'Yilan County' },
  { Province: 27, ID: 327, Name: 'Hsinchu County' },
  { Province: 27, ID: 328, Name: 'Taoyuan County' },
  { Province: 27, ID: 329, Name: 'Miaoli County' },
  { Province: 27, ID: 330, Name: 'Changhua County' },
  { Province: 27, ID: 331, Name: 'Changhua County' },
  { Province: 27, ID: 332, Name: 'Yunlin County' },
  { Province: 27, ID: 333, Name: 'Pingtung County' },
  { Province: 27, ID: 334, Name: 'Taitung County' },
  { Province: 27, ID: 335, Name: 'Hualien County' },
  { Province: 27, ID: 336, Name: 'Penghu County' },
  { Province: 28, ID: 337, Name: 'Hong Kong Island' },
  { Province: 28, ID: 338, Name: 'Kowloon' },
  { Province: 28, ID: 339, Name: 'New Territories' },
  { Province: 29, ID: 340, Name: 'Macau Peninsula' },
  { Province: 29, ID: 341, Name: 'outlying islands' },
  { Province: 30, ID: 342, Name: 'overseas' },
  { Province: 31, ID: 343, Name: 'Tianjin' },
  { Province: 32, ID: 344, Name: 'Shenyang city' },
  { Province: 32, ID: 345, Name: 'Dalian' },
  { Province: 32, ID: 346, Name: 'Anshan City' },
  { Province: 32, ID: 347, Name: 'Fushun City' },
  { Province: 32, ID: 348, Name: 'Benxi' },
  { Province: 32, ID: 349, Name: 'Dandong' },
  { Province: 32, ID: 350, Name: 'Jinzhou' },
  { Province: 32, ID: 351, Name: 'Yingkou' },
  { Province: 32, ID: 352, Name: 'Fuxin' },
  { Province: 32, ID: 353, Name: 'Liaoyang' },
  { Province: 32, ID: 354, Name: 'Panjin' },
  { Province: 32, ID: 355, Name: 'Tieling' },
  { Province: 32, ID: 356, Name: 'Chaoyang' },
  { Province: 32, ID: 357, Name: 'Huludao City' },
  { Province: 33, ID: 358, Name: 'Hohhot' },
  { Province: 33, ID: 359, Name: 'Baotou' },
  { Province: 33, ID: 360, Name: 'Wuhai' },
  { Province: 33, ID: 361, Name: 'Chifeng' },
  { Province: 33, ID: 362, Name: 'Tongliao' },
  { Province: 33, ID: 363, Name: 'Ordos' },
  { Province: 33, ID: 364, Name: 'Hulunbeir' },
  { Province: 33, ID: 365, Name: 'Bayannaoer' },
  { Province: 33, ID: 366, Name: 'Wulanchabu' },
  { Province: 33, ID: 367, Name: 'Hinggan League' },
  { Province: 33, ID: 368, Name: 'Xilin Gol League' },
  { Province: 33, ID: 369, Name: 'Alxa League' },
  { Province: 34, ID: 370, Name: 'Taiyuan' },
  { Province: 34, ID: 371, Name: 'Datong' },
  { Province: 34, ID: 372, Name: 'Yangquan' },
  { Province: 34, ID: 373, Name: 'Changzhi' },
  { Province: 34, ID: 374, Name: 'Jincheng' },
  { Province: 34, ID: 375, Name: 'Shuozhou' },
  { Province: 34, ID: 376, Name: 'Jinzhong' },
  { Province: 34, ID: 377, Name: 'Yuncheng' },
  { Province: 34, ID: 378, Name: 'Xinzhou' },
  { Province: 34, ID: 379, Name: 'Linfen City' },
  { Province: 34, ID: 380, Name: 'Luliang' },
  { Province: 35, ID: 381, Name: 'Shijiazhuang City' },
  { Province: 35, ID: 382, Name: 'Tangshan' },
  { Province: 35, ID: 383, Name: 'Qinhuangdao' },
  { Province: 35, ID: 384, Name: 'Handan' },
  { Province: 35, ID: 385, Name: 'Xingtai city' },
  { Province: 35, ID: 386, Name: 'Baoding' },
  { Province: 35, ID: 387, Name: 'Zhangjiakou' },
  { Province: 35, ID: 388, Name: 'Chengde' },
  { Province: 35, ID: 389, Name: 'Cangzhou' },
  { Province: 35, ID: 390, Name: 'Langfang City' },
  { Province: 35, ID: 391, Name: 'Hengshui' },
  { Province: 36, ID: 392, Name: 'other' },
  { Province: 26, ID: 393, Name: 'Hutubi County, Changji Prefecture' },
  { Province: 11, ID: 394, Name: 'Changge' },
  { Province: 8, ID: 395, Name: 'Jinjiang' },
]

//仅省市选择
for (const provinceItem of provinceData) {
  enareaData.push({
    value: provinceItem.ID, // 省份code值
    label: provinceItem.Name, // 省份汉字
    children: [],
  })
}
for (const provinceItem of enareaData) {
  for (const cityItem of cityData) {
    if (cityItem.Province === provinceItem.value) {
      provinceItem.children.push({
        value: cityItem.ID,
        label: cityItem.Name,
      })
    }
  }
}
export default enareaData



// WEBPACK FOOTER //
// ./src/utils/enarea.js